import React from "react";
import ExpertServicesHeader from "./ExpertServicesHeader/ExpertServicesHeader";
import CareerCategoriesGrid from "./CareerCategoriesGrid/CareerCategoriesGrid";
import Contactus from "../CommonPage/Contact/Contactus";
import TestimonialSection from "../Career_Solutions/TestimonialSection/TestimonialSection";
import FaqSection from "../Career_Solutions/FaqSection/FaqSection";
import ScamAlertBanner from "../common_components/scamAlertBanner/ScamAlertBanner";

function Services() {
  return (
    <>
      <ExpertServicesHeader />

      <CareerCategoriesGrid />

      <Contactus />

      <TestimonialSection />

      <FaqSection />

      <ScamAlertBanner />
    </>
  );
}

export default Services;
